/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Triggers_Empty_DescriptionInputs */



/**
* | output |
* | --- |
* | "Add a time or an event to run this agent automatically." |
*
* @param {Agent_Triggers_Empty_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_triggers_empty_description = /** @type {((inputs?: Agent_Triggers_Empty_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Triggers_Empty_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fügen Sie einen Auslöser hinzu, um diesen Agenten automatisch auszuführen.")
	return /** @type {LocalizedString} */ ("Add a time or an event to run this agent automatically.")
});